export default __webpack_public_path__ + "static/media/image4.bdce4e4d.webp";